import { render } from "./more-attachment.vue?vue&type=template&id=0835e7fc"
import script from "./more-attachment.vue?vue&type=script&lang=js"
export * from "./more-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__